interface PaymentGroupBannerDataAnalyticsData {
    value: string;
    context: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface PaymentGroupBannerData {
    asset_url: string;
    analytics_data: PaymentGroupBannerDataAnalyticsData;
}
/* eslint-enable @typescript-eslint/naming-convention */

export const BANNER_ACTION_TYPE = {
    CUSTOM: "web-payments",
    DEEPLINK: "deeplink",
    SCROLL: "scroll",
};

/* eslint-disable @typescript-eslint/naming-convention */
export interface BannerParams {
    entity_counters: {
        entity_id: string;
        entity_type: string;
        count: number;
    }[];
}
/* eslint-enable @typescript-eslint/naming-convention */
